/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import _ from "underscore";
import BaseContainer from "./BaseContainer";
import {getStore} from "../services/Dynamic";
import {NotificationActions} from "../services/Notification";

/**
 * Use as:
 *
 * class MyContainer extends BaseDynamicContainer {
 *      constructor(props) {
 *          # Creates BaseStore with resource name "person" and sets this.state.p to reference the store's state.
 *          super(props, {"p": "person"});
 *      }
 * }
 *
 *
 * @extends BaseContainer
 */
class BaseDynamicContainer extends BaseContainer {
    getStoreByName(props, name) {
        return getStore(name);
    }

    /**
     * Called when specified store fails to load data.
     * By default this method uses notification to display error.
     * @param key Store key
     * @param {BaseRestStoreState} newState Store new state
     * @param {BaseRestStoreState} oldState Store old state
     */
    loadingFailed(key, newState) {
        NotificationActions.actionError.defer(newState.action);
    }

    /**
     * Returns error information about the form data. Should be in the form:
     * {
     *      fieldName: errorMessage,
     *      fieldName: [errorMessage, ...]
     * }
     * @param {RestAction} action
     * @return {Object}
     */
    getErrorList(action) {
        if (action && action.error && action.error.code === 400 && action.error.reason && action.error.reason.startsWith("resource:")) {
            let errorStr = action.error.reason.substring(9);
            if (errorStr.indexOf("=") >= 0) {
                let errors = errorStr.split(":");
                let errorInfo = {};
                for (let val of errors) {
                    let e = val.split("=");
                    if (_.has(errorInfo, e[0])) {
                        if (_.isArray(errorInfo[e[0]])) {
                            errorInfo[e[0]].push(e[1]);
                        } else {
                            errorInfo[e[0]] = [errorInfo[e[0]], e[1]];
                        }
                    } else {
                        errorInfo[e[0]] = e[1];
                    }
                }
                return errorInfo;
            }
        }
        return null;
    }

}

export default BaseDynamicContainer;
